import { TableProps } from 'antd/es/table';

export const mapColumns: TableProps['columns'] = [
  {
    title: 'REQUEST NO.',
    dataIndex: 'requestNo',
    key: 'requestNo',
    ellipsis: true,
  },
  {
    title: 'REQUEST TYPE',
    dataIndex: 'requestTypeId',
    key: 'requestTypeId',
    ellipsis: true,
  },
  {
    title: 'EMPLOYEE',
    dataIndex: 'employee',
    key: 'employee',
    ellipsis: true,
  },
  {
    title: 'COMPANY',
    dataIndex: 'company',
    key: 'company',
    ellipsis: true,
  },
  {
    title: 'DATE & TIME CREATED',
    dataIndex: 'created',
    key: 'created',
    ellipsis: true,
  },
  {
    title: 'LAST UPDATE',
    dataIndex: 'lastUpdated',
    key: 'lastUpdated',
    ellipsis: true,
  },
  {
    title: 'REQUEST DESCRIPTION',
    dataIndex: 'headerDesc',
    key: 'headerDesc',
    ellipsis: true,
  },
  {
    title: 'REMARKS',
    dataIndex: 'remarks',
    key: 'remarks',
    ellipsis: true,
  },
];
